import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api/v1`;

// Create axios instance
const api = axios.create({
  baseURL: API_BASE,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('carbiq_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('carbiq_admin_token');
      window.location.href = '/admin/login';
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (username, password) => 
  api.post('/admin/auth/login', { username, password });

// Stats
export const getStats = () => api.get('/admin/stats');

// Foods
export const getFoods = (params) => api.get('/foods', { params });
export const getFood = (id) => api.get(`/foods/${id}`);
export const createFood = (data) => api.post('/admin/foods', data);
export const updateFood = (id, data) => api.put(`/admin/foods/${id}`, data);
export const deleteFood = (id) => api.delete(`/admin/foods/${id}`);
export const bulkCreateFoods = (data) => api.post('/admin/foods/bulk', data);

// Recipes
export const getRecipes = (params) => api.get('/recipes', { params });
export const getRecipe = (id) => api.get(`/recipes/${id}`);
export const createRecipe = (data) => api.post('/admin/recipes', data);
export const updateRecipe = (id, data) => api.put(`/admin/recipes/${id}`, data);
export const deleteRecipe = (id) => api.delete(`/admin/recipes/${id}`);

// Rescue Actions
export const getRescueActions = () => api.get('/rescue-actions');
export const createRescueAction = (data) => api.post('/admin/rescue-actions', data);
export const updateRescueAction = (id, data) => api.put(`/admin/rescue-actions/${id}`, data);
export const deleteRescueAction = (id) => api.delete(`/admin/rescue-actions/${id}`);

// Smart Combos
export const getCombos = (params) => api.get('/combos', { params });
export const createCombo = (data) => api.post('/admin/combos', data);
export const updateCombo = (id, data) => api.put(`/admin/combos/${id}`, data);
export const deleteCombo = (id) => api.delete(`/admin/combos/${id}`);

// Daily Tips
export const getTips = () => api.get('/tips/today');
export const getAllTips = () => api.get('/admin/tips');
export const createTip = (data) => api.post('/admin/tips', data);
export const updateTip = (id, data) => api.put(`/admin/tips/${id}`, data);
export const deleteTip = (id) => api.delete(`/admin/tips/${id}`);

// App Config
export const getConfig = () => api.get('/admin/config');
export const updateConfig = (key, value) => api.put(`/admin/config/${key}`, { value });

// Content Sync (for getting all tips)
export const getContentSync = () => api.get('/content/sync');

export default api;
